export default "__VITE_ASSET__DyHl_ab3__"